<template>
    <div class="hidden sm:block">
        <div class="py-8">
            <div class="border-gray-500-200 border-t" />
        </div>
    </div>
</template>
